import isValidEmail from 'Shared/functions/validateEmail'

export default function validate({ brand, setErrors }) {
  const validationErrors = {}

  if (brand.customHomepageUrl && !isValidURL(brand.customHomepageUrl)) {
    validationErrors['customHomepageUrl'] = 'Please enter a valid URL (including http:// or https://) for the Home webpage URL'
  }

  if (brand.supportEmail && !isValidEmail(brand.supportEmail)) {
    validationErrors['supportEmail'] = 'Please enter a valid email address'
  }

  setErrors(validationErrors)
}


function isValidURL(string) {
    try {
        const url = new URL(string)
        return ['http:', 'https:'].includes(url.protocol) && !!url.hostname
    } catch (_) {
        return false
    }
}
